// Author : NANDHAKUMAR
// Version :0.0.1
// MODIFIED DATE: 14/11/2025
import savingCollectionTypes from './saving-collection.types';

/** ***************** GET SEARCH MEMBER SAVING DETAILS START *********************** */
export const getSearchMemberSavingDetailsStart = (getData: any) => ({
	type: savingCollectionTypes.GET_SEARCH_MEMBER_SAVING_DETAILS_START,
	payload: getData,
});

export const getSearchMemberSavingDetailsSuccess = (successData: any) => ({
	type: savingCollectionTypes.GET_SEARCH_MEMBER_SAVING_DETAILS_SUCCESS,
	payload: successData,
});

export const getSearchMemberSavingDetailsFailure = (failureData: any) => ({
	type: savingCollectionTypes.GET_SEARCH_MEMBER_SAVING_DETAILS_FAILURE,
	payload: failureData,
});

export const getSearchMemberSavingDetailsResponseReset = () => ({
	type: savingCollectionTypes.GET_SEARCH_MEMBER_SAVING_DETAILS_RESPONSE_RESET,
});

export const getSearchMemberSavingDetailsResponseChanged = () => ({
	type: savingCollectionTypes.GET_SEARCH_MEMBER_SAVING_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET SEARCH MEMBER SAVING DETAILS END *********************** */

/** ***************** FETCH SEARCH MEMBER SAVING DETAILS START *********************** */
export const fetchSearchMemberSavingDetailsStart = (getData: any) => ({
	type: savingCollectionTypes.FETCH_MEMBER_SAVING_DETAILS_START,
	payload: getData,
});

export const fetchSearchMemberSavingDetailsSuccess = (successData: any) => ({
	type: savingCollectionTypes.FETCH_MEMBER_SAVING_DETAILS_SUCCESS,
	payload: successData,
});

export const fetchSearchMemberSavingDetailsFailure = (failureData: any) => ({
	type: savingCollectionTypes.FETCH_MEMBER_SAVING_DETAILS_FAILURE,
	payload: failureData,
});

export const fetchSearchMemberSavingDetailsResponseReset = () => ({
	type: savingCollectionTypes.FETCH_MEMBER_SAVING_DETAILS_RESPONSE_RESET,
});

export const fetchSearchMemberSavingDetailsResponseChanged = () => ({
	type: savingCollectionTypes.FETCH_MEMBER_SAVING_DETAILS_RESPONSE_CHANGED,
});
/** ***************** FETCH SEARCH MEMBER SAVING DETAILS END *********************** */

/** ***************** GET PARTICULAR ACCOUNT INFO START *********************** */
export const getParticularAccountInfoStart = (getData: any) => ({
	type: savingCollectionTypes.GET_PARTICULAR_ACCOUNT_INFO_START,
	payload: getData,
});

export const getParticularAccountInfoSuccess = (successData: any) => ({
	type: savingCollectionTypes.GET_PARTICLUAR_ACCOUNT_INFO_SUCCESS,
	payload: successData,
});

export const getParticularAccountInfoFailure = (failureData: any) => ({
	type: savingCollectionTypes.GET_PARTICULAR_ACCOUNT_INFO_FAILURE,
	payload: failureData,
});

export const getParticularAccountInfoResponseReset = () => ({
	type: savingCollectionTypes.GET_PARTICULAR_ACCOUNT_INFO_RESPONSE_RESET,
});

export const getParticularAccountInfoResponseChanged = () => ({
	type: savingCollectionTypes.GET_PARTICULAR_ACCOUNT_INFO_RESPONSE_CHANGED,
});
/** ***************** GET PARTICULAR ACCOUNT INFO END *********************** */

/** ***************** ADD SAVING MEMBER SAVING ACCOUNT START *********************** */
export const addSavingMemberSavingDetailsStart = (getData: any) => ({
	type: savingCollectionTypes.ADD_SAVING_MEMBER_SAVING_ACCOUNT_START,
	payload: getData,
});

export const addSavingMemberSavingDetailsSuccess = (successData: any) => ({
	type: savingCollectionTypes.ADD_SAVING_MEMBER_SAVING_ACCOUNT_SUCCESS,
	payload: successData,
});

export const addSavingMemberSavingDetailsFailure = (failureData: any) => ({
	type: savingCollectionTypes.ADD_SAVING_MEMBER_SAVING_ACCOUNT_FAILURE,
	payload: failureData,
});

export const addSavingMemberSavingDetailsResponseReset = () => ({
	type: savingCollectionTypes.ADD_SAVING_MEMBER_SAVING_ACCOUNT_RESPONSE_RESET,
});

export const addSavingMemberSavingDetailsResponseChanged = () => ({
	type: savingCollectionTypes.ADD_SAVING_MEMBER_SAVING_ACCOUNT_RESPONSE_CHANGED,
});
/** ***************** ADD SAVING MEMBER SAVING ACCOUNT END *********************** */

/** ***************** DELETE SAVING MEMBER SAVING ACCOUNT START *********************** */
export const deleteSavingMemberSavingDetailsStart = (getData: any) => ({
	type: savingCollectionTypes.DELETE_SAVING_MEMBER_SAVING_ACCOUNT_START,
	payload: getData,
});

export const deleteSavingMemberSavingDetailsSuccess = (successData: any) => ({
	type: savingCollectionTypes.DELETE_SAVING_MEMBER_SAVING_ACCOUNT_SUCCESS,
	payload: successData,
});

export const deleteSavingMemberSavingDetailsFailure = (failureData: any) => ({
	type: savingCollectionTypes.DELETE_SAVING_MEMBER_SAVING_ACCOUNT_FAILURE,
	payload: failureData,
});

export const deleteSavingMemberSavingDetailsResponseReset = () => ({
	type: savingCollectionTypes.DELETE_SAVING_MEMBER_SAVING_ACCOUNT_RESPONSE_RESET,
});

export const deleteSavingMemberSavingDetailsResponseChanged = () => ({
	type: savingCollectionTypes.DELETE_SAVING_MEMBER_SAVING_ACCOUNT_RESPONSE_CHANGED,
});
/** ***************** DELETE SAVING MEMBER SAVING ACCOUNT END *********************** */
